var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotLeagueFifaCornerMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2203_391683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 53,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 42.998H0V-0.00195312H53V42.998Z",
    fill: "url(#paint0_linear_2203_391683)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2203_391683)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2203_391683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: -16,
    width: 209,
    height: 119
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.428 102.457H13L13 -16.0005H221.428V102.457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2203_391683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.022 185.689H65.8213C40.6386 185.689 20.2227 164.244 20.2227 137.79H65.8213C40.6386 137.79 20.2227 116.345 20.2227 89.8914V41.9888H65.8213C40.6386 41.9888 20.2227 20.5429 20.2227 -5.91017L20.2227 -53.8128C20.2227 -80.2659 40.6386 -101.712 65.8213 -101.712H157.022C182.205 -101.712 202.62 -80.2659 202.62 -53.8128C202.62 -27.3561 182.205 -5.91382 157.022 -5.91382H202.62C202.62 20.5393 182.205 41.9852 157.022 41.9852H202.62V89.8842H157.022C182.205 89.8842 202.62 111.33 202.62 137.783C202.624 164.244 182.208 185.689 157.022 185.689Z",
    fill: "#64FEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25 176.949H68.5944C44.9407 176.949 25.7666 156.808 25.7666 131.961H68.5944C44.9407 131.961 25.7666 111.819 25.7666 86.9724V41.9839H68.5944C44.9407 41.9839 25.7666 21.8425 25.7666 -3.0045L25.7666 -47.9929C25.7666 -72.8399 44.9407 -92.9814 68.5944 -92.9814H154.25C177.904 -92.9814 197.078 -72.8399 197.078 -47.9929C197.078 -23.1459 177.904 -3.0045 154.25 -3.0045H197.078C197.078 21.8425 177.904 41.9839 154.25 41.9839H197.078V86.9724H154.25C177.904 86.9724 197.078 107.114 197.078 131.961C197.078 156.808 177.904 176.949 154.25 176.949Z",
    fill: "#3B5BFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.478 168.217H71.367C49.2457 168.217 31.3135 149.38 31.3135 126.143H71.367C49.2457 126.143 31.3135 107.306 31.3135 84.0683V41.9941H71.367C49.2457 41.9941 31.3135 23.1572 31.3135 -0.0801392L31.3135 -42.1543C31.3135 -65.3916 49.2457 -84.2286 71.367 -84.2286H151.478C173.599 -84.2286 191.531 -65.3916 191.531 -42.1543C191.531 -18.9171 173.599 -0.0801392 151.478 -0.0801392H191.531C191.531 23.1572 173.599 41.9941 151.478 41.9941H191.531V84.0683H151.478C173.599 84.0683 191.531 102.905 191.531 126.143C191.531 149.38 173.599 168.217 151.478 168.217Z",
    fill: "#FEB601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.704 159.475H74.1383C53.5494 159.475 36.8555 141.942 36.8555 120.311H74.1383C53.5494 120.311 36.8555 102.778 36.8555 81.1473V41.9836H74.1383C53.5494 41.9836 36.8555 24.4511 36.8555 2.81993V-36.3437C36.8555 -57.9713 53.5459 -75.5074 74.1383 -75.5074H148.704C169.293 -75.5074 185.987 -57.975 185.987 -36.3437C185.987 -14.7161 169.296 2.81993 148.704 2.81993H185.987C185.987 24.4475 169.296 41.9836 148.704 41.9836H185.987V81.1473H148.704C169.293 81.1473 185.987 98.6797 185.987 120.311C185.987 141.939 169.296 159.475 148.704 159.475Z",
    fill: "#F93549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.93 150.734H76.9099C57.85 150.734 42.4014 134.503 42.4014 114.485H76.9099C57.85 114.485 42.4014 98.2533 42.4014 78.2354V41.986H76.9099C57.85 41.986 42.4014 25.7544 42.4014 5.7365V-30.513C42.4014 -50.5345 57.8534 -66.7624 76.9099 -66.7624H145.93C164.99 -66.7624 180.439 -50.5308 180.439 -30.513C180.439 -10.4915 164.987 5.7365 145.93 5.7365H180.439C180.439 25.758 164.987 41.986 145.93 41.986H180.439V78.2354H145.93C164.99 78.2354 180.439 94.467 180.439 114.485C180.439 134.506 164.987 150.734 145.93 150.734Z",
    fill: "#64FEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.157 142.006H79.685C62.1575 142.006 47.9473 127.079 47.9473 108.667H79.685C62.1575 108.667 47.9473 93.7399 47.9473 75.3281V41.9892H79.685C62.1575 41.9892 47.9473 27.0621 47.9473 8.65028V-24.6886C47.9473 -43.1004 62.1575 -58.0275 79.685 -58.0275H143.157C160.685 -58.0275 174.895 -43.1004 174.895 -24.6886C174.895 -6.27681 160.685 8.65028 143.157 8.65028H174.895C174.895 27.0621 160.685 41.9892 143.157 41.9892H174.895V75.3281H143.157C160.685 75.3281 174.895 90.2552 174.895 108.667C174.895 127.079 160.685 142.006 143.157 142.006Z",
    fill: "#3B5BFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2203_391683",
    x1: -7.5,
    y1: 21,
    x2: 53,
    y2: 18.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190244,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94355"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotLeagueFifaCornerMask);
export default __webpack_public_path__ + "static/media/hot-league-fifa-corner-mask.347e905d3c669ebf8e4ac3d863a683c6.svg";
export { ForwardRef as ReactComponent };